import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "lists-coupon-content" }
const _hoisted_2 = { width: "100%" }
const _hoisted_3 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = {
  width: "50%",
  class: "text-right"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "lists-coupon-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visible) = $event)),
    width: "500px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.selectedCoupon?.imageUrl)
              ? (_openBlock(), _createBlock(_component_v_img, {
                  key: 0,
                  src: _ctx.selectedCoupon?.imageUrl,
                  "aspect-ratio": _ctx.imageAspectRatio,
                  width: "450px",
                  eager: "",
                  onLoad: _ctx.handleImageLoad
                }, null, 8, ["src", "aspect-ratio", "onLoad"]))
              : _createCommentVNode("", true),
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("tbody", null, [
                (_ctx.selectedCoupon?.state !== 'new')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("tr", null, [
                        _cache[1] || (_cache[1] = _createElementVNode("td", { width: "50%" }, "Odoo Id", -1)),
                        _createElementVNode("td", _hoisted_3, [
                          (_ctx.selectedCoupon?.importResult?.odooId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.selectedCoupon?.importResult.odooId), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_5, " - "))
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("td", { width: "50%" }, "Revu par", -1)),
                        _createElementVNode("td", _hoisted_6, [
                          (_ctx.selectedCoupon?.approval?.reviewer?.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.selectedCoupon?.approval.reviewer.email), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_8, " - "))
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[3] || (_cache[3] = _createElementVNode("td", { width: "50%" }, "Date de révision", -1)),
                        _createElementVNode("td", _hoisted_9, [
                          (_ctx.selectedCoupon?.approval.reviewedAt)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.format(_ctx.selectedCoupon?.approval.reviewedAt, 'yyyy-MM-dd HH:mm:ss')), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_11, " - "))
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", null, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", { width: "50%" }, "Numéro de compte", -1)),
                  _createElementVNode("td", _hoisted_12, [
                    (_ctx.selectedCoupon?.accountNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.selectedCoupon?.accountNumber), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_14, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", { width: "50%" }, "Numéro de coupon", -1)),
                  _createElementVNode("td", _hoisted_15, [
                    (_ctx.selectedCoupon?.couponNumber)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.selectedCoupon?.couponNumber), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", { width: "50%" }, "Source", -1)),
                  _createElementVNode("td", _hoisted_18, [
                    (_ctx.selectedCoupon?.source)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.selectedCoupon?.source), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_20, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", { width: "50%" }, "État", -1)),
                  _createElementVNode("td", _hoisted_21, [
                    (_ctx.selectedCoupon?.state)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.selectedCoupon?.state), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_23, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", { width: "50%" }, "Type", -1)),
                  _createElementVNode("td", _hoisted_24, [
                    (_ctx.selectedCoupon?.couponType)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.selectedCoupon.couponType.code || _ctx.selectedCoupon.couponType.label), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_26, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", { width: "50%" }, "Montant", -1)),
                  _createElementVNode("td", _hoisted_27, [
                    (_ctx.selectedCoupon?.amount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.selectedCoupon?.amount), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_29, " - "))
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", { width: "50%" }, "Date", -1)),
                  _createElementVNode("td", _hoisted_30, [
                    (_ctx.selectedCoupon?.createdAt)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.format(_ctx.selectedCoupon?.createdAt, 'yyyy-MM-dd HH:mm:ss')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_32, " - "))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_v_btn, {
              style: { padding: '14px 24px', display: 'flex', justifyContent: 'center', alignItems: 'center' },
              onClick: _ctx.resetSelectedCoupon
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("Close", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}